export class User {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  password: string;
  emailVerified: boolean;
  phoneNumber: string;
  adresse: string;
  grade: string;
  categorie: string;
}
